import apiClient from "./api";

let cachedUserData = null;

export const fetchUserData = async (force = false) => {
  try {
    if (cachedUserData && !force) {
      return cachedUserData;
    }

    const token = localStorage.getItem("token");
    if (!token) return null;

    const response = await apiClient.get("/regdetail", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data && typeof response.data === "object") {
      const { role, emp_name, emp_id } = response.data;

      if (role) localStorage.setItem("role", role);
      if (emp_name) localStorage.setItem("emp_name", emp_name);
      if (emp_id) localStorage.setItem("emp_id", emp_id);

      cachedUserData = response.data; // ✅ CACHE
      return response.data;
    }

    console.error("Invalid response format", response.data);
    return null;
  } catch (error) {
    console.error("Error fetching user data:", error);

    if (error.response?.status === 401) {
      clearAuthData();
    }

    return null;
  }
};

export const clearAuthData = () => {
  cachedUserData = null;
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("emp_name");
  localStorage.removeItem("emp_id");


  // ✅ Remove all dynamic placement filters
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("placementDbFilters")) {
      localStorage.removeItem(key);
    }
  });

  localStorage.removeItem("placedStudentFilters");
  localStorage.removeItem("jobDashboardFilters");
  localStorage.removeItem("jobDashboard-selectedColumns");

  sessionStorage.removeItem("lastActiveTab");
  sessionStorage.removeItem("lastJobReqPath");
};

export const logout = (navigate) => {
  clearAuthData();
  navigate("/login", { replace: true });
};
